import { useMutation } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { pollAIResult } from "../ai/poll";

export const getTraduction = async (resume: Record<string, any>, language: string) => {
  const res = await axios.post<{ key: string }>("ai/translate", {
    data: JSON.stringify(resume),
    language: language,
  });
  return pollAIResult<Record<string, any>>(res.data.key);
};

export const useTranslation = () => {
  return useMutation({
    mutationFn: ({ resume, language }: { resume: Record<string, any>; language: string }) =>
      getTraduction(resume, language),
  });
};
